import { render, staticRenderFns } from "./viewDoctorDocuments.vue?vue&type=template&id=43f00c47"
import script from "./viewDoctorDocuments.vue?vue&type=script&lang=js"
export * from "./viewDoctorDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports